import { TRANSITIONS, INITIAL_STATE } from './utils';
import HANDLERS from './handlers';

export default {
    data() {
        return {
            currentState: INITIAL_STATE,
        };
    },
    created() {
        if (!(TRANSITIONS instanceof Object)) {
            throw '"TRANSITIONS" must be an object';
        }
        if (!(HANDLERS instanceof Object)) {
            throw '"HANDLERS" must be an object';
        }
    },
    methods: {
        $transition(action, event = {}) {
            const { [this.currentState]: actions = {} } = TRANSITIONS;
            const { type } = action;
            const { [type]: next } = actions;
            const node = `${this.currentState}/${type}`;

            if (!next) {
                throw new Error(`Invalid transition definition for state node '${node}'`);
            }
            console.log(`[transition]: ${node}`);
            Object.assign(this.$data, {
                currentState: next,
                ...this.$command(next, action, event),
            });
        },
        async $command(nextState, action, event = {}) {
            const handler = HANDLERS[nextState];
            await this.$nextTick();
            handler && handler.call(this, { ...action, event });
        },
    },
};
